import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";
import { SITE } from "@/lib/site";
import { GROUPS } from "@/lib/products";

const QUICK_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/#about" },
  { label: "Products", to: "/catalogue" },
  { label: "Private Label", to: "/#private-label" },
  { label: "Export", to: "/#export" },
  { label: "Contact Us", to: "/#contact" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-navy-deep text-white">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-10 md:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <img src="/assets/brand/logo.png" alt="RBL EXIM logo" className="h-16 w-16 object-contain" />
              <p className="font-display text-xl font-semibold tracking-tight">RBL EXIM</p>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-white/65">
              Premium Indian Food Products | Export | Private Label Solutions
            </p>
            <a
              href={SITE.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-gold transition-colors duration-300 hover:text-white"
            >
              <Instagram size={16} /> {SITE.instagram}
            </a>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold">Quick Links</p>
            <ul className="mt-6 space-y-3">
              {QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-sm text-white/70 transition-colors duration-300 hover:text-gold"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold">Product Groups</p>
            <ul className="mt-6 space-y-3">
              {GROUPS.map((g) => (
                <li key={g.slug}>
                  <Link
                    to={`/products/${g.slug}`}
                    data-testid={`footer-category-${g.slug}`}
                    className="text-sm text-white/70 transition-colors duration-300 hover:text-gold"
                  >
                    {g.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold">Contact</p>
            <ul className="mt-6 space-y-4 text-sm text-white/70">
              <li>
                <a href={SITE.phoneHref} data-testid="footer-phone" className="flex items-center gap-2.5 transition-colors duration-300 hover:text-gold">
                  <Phone size={15} className="shrink-0 text-gold" /> {SITE.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex items-center gap-2.5 transition-colors duration-300 hover:text-gold">
                  <Mail size={15} className="shrink-0 text-gold" /> {SITE.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5" data-testid="footer-address">
                <MapPin size={15} className="mt-0.5 shrink-0 text-gold" />
                <span className="leading-relaxed">{SITE.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col justify-between gap-2 px-5 py-6 text-xs text-white/50 sm:flex-row md:px-10">
          <p data-testid="footer-copyright">© 2026 RBL EXIM. All Rights Reserved.</p>
          <p>{SITE.website} · {SITE.city}</p>
        </div>
      </div>
    </footer>
  );
}
